import { fallbackValue } from "constants/fallbackConstant";

const formatDateForInput = (date) => {
  if (!date) return fallbackValue;

  // Handle DateTimeInterval objects with from/to or start/end properties
  if (typeof date === "object" && ((date.from && date.to) || (date.start && date.end))) {
    const start = new Date(date.from || date.start);
    const end = new Date(date.to || date.end);

    // Format the date part
    const formattedDate = start.toISOString().split("T")[0];

    // Format the time part in 24-hour format
    const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const options = { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: localTimeZone };
    
    const startHour = start.toLocaleTimeString([], options).split(":")[0];
    const endHour = end.toLocaleTimeString([], options).split(":")[0];

    return `${formattedDate} / ${startHour} - ${endHour}`;
  }

  const parsedDate = new Date(date);
  const formattedDate = parsedDate.toISOString().split("T")[0];

  // Format the time part in 24-hour format
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };
  const formattedTime = parsedDate.toLocaleTimeString([], options);

  return `${formattedDate} / ${formattedTime}`;
};

export default formatDateForInput;
